if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewed extends customElements.get('card-product-slider') {
    constructor() {
      super();

      this.section = this.closest('.js-section');
      this.sliderWrapper = this.querySelector('.swiper-wrapper');
      this.productHandle = this.dataset.productHandle;

      this.fetchRecentProducts();
    }

    async fetchRecentProducts() {
      const productHandles = localStorage.getItem('recently-viewed');

      if (!productHandles || !this.sliderWrapper) {
        return;
      }

      const productHandlesArray = productHandles
        .split(',')
        .map(productHandle => productHandle.trim())
        .filter(Boolean)
        .filter(productHandle => productHandle !== this.productHandle);

      if (productHandlesArray.length === 0) {
        return;
      }

      await Promise.all(
        productHandlesArray.map(productHandle => {
          return this.fetchRecentProductVariantCards(productHandle);
        })
      );

      if (!this.sliderWrapper.querySelector('.swiper-slide')) {
        return;
      }

      this.initSlider();
      this.section?.classList.remove('hidden');
    }

    async fetchRecentProductVariantCards(productHandle) {
      try {
        const productCardResponse = await fetch(
          `${window.Shopify.routes.root}products/${productHandle}?view=card-variants`
        );

        if (!productCardResponse.ok) {
          this.removeProductHandle(productHandle);
          return;
        }

        const productCardHTML = await productCardResponse.text();

        const tempElement = document.createElement('div');
        tempElement.innerHTML = productCardHTML.trim();

        const productSlides = tempElement.querySelectorAll(
          '.swiper-slide.card-product-slider__slide'
        );

        if (!productSlides.length) {
          return;
        }

        productSlides.forEach(productSlide => {
          if (
            !productSlide.querySelector('card-product') &&
            !productSlide.querySelector('.card-product')
          ) {
            return;
          }

          this.sliderWrapper.append(productSlide);
        });
      } catch (error) {
        // console.log(error);
      }
    }

    removeProductHandle(productHandle) {
      const productHandles = localStorage.getItem('recently-viewed');

      if (!productHandles) {
        return;
      }

      const updatedProductHandles = productHandles
        .split(',')
        .map(handle => handle.trim())
        .filter(Boolean)
        .filter(handle => handle !== productHandle)
        .join(',');

      localStorage.setItem('recently-viewed', updatedProductHandles);
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewed);
}